import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslate } from "../../translate";
import { Formik, ErrorMessage } from "formik";
import CustomInlineToast from "../CustomInlineToast";
import Button from "@ingka/button";
import informationCircle from "@ingka/ssr-icon/paths/information-circle";
import ValidationErrorMessage from "../ValidationErrorMessage";
import infoIcon from "@ingka/ssr-icon/paths/information-circle";
import SSRIcon from "@ingka/ssr-icon";
import * as Yup from "yup";
import { PromptModalContainer } from "@afg-ikea/ikea-kiosk-related-components/dist/exports";
import {
  fetchCNCManualWeborderStatus,
  resetCNCManualWeborderStatus,
  modifyCNCManualWeborderStatus,
  resetCNCScannedWeborderStatus,
} from "../../redux/cncWebOrder/cncWebOrderActions";
import BarcodeReader from "react-barcode-reader";
import {
  fetchCNCScannedWeborderStatus,
  modifyCNCScannedWeborderStatus,
  setCNCScannedData,
} from "../../redux/cncWebOrder/cncWebOrderActions";
import Constants from "../../Constants";
import { io } from "socket.io-client";

import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/forms/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/hyperlink/style.scss";
import "./ClickAndCollectOrderModalBody.scss";
import { getCounterNo, prepareCounterToast } from "../../util/utils";

const ClickAndCollectOrderModalBody = ({ mode }) => {
  const i18n = useTranslate();
  const { t, isRtl } = i18n;
  const dispatch = useDispatch();
  const toast = {
    theme: {
      positive: "positive",
      negative: "negative",
      informative: "informative",
    },
  };
  const initialToastState = {
    manualOrder: {
      visible: false,
      title: "",
      desc: "",
      variant: toast.theme.positive,
    },
    scannedOrder: {
      visible: false,
      title: "",
      desc: "",
      variant: toast.theme.positive,
    },
  };
  const [toastState, setToastState] = useState(initialToastState);
  const initialPromptModalState = { visible: false, message: "" };
  const [promptModalState, setPromptModalState] = useState(
    initialPromptModalState
  );

  const disableScan = useRef(null);

  const cncManualWebOrderObj = useSelector(
    ({ cncWebOrder: { manualWebOrder } }) => manualWebOrder
  );
  const cncManualWebOrderError = useSelector(
    ({ cncWebOrder }) => cncWebOrder.manualWebOrder?.error
  );

  const cncScannedWebOrderObj = useSelector(
    ({ cncWebOrder: { scannedWeborder } }) => scannedWeborder
  );
  const cncScannedWebOrderError = useSelector(
    ({ cncWebOrder }) => cncWebOrder.scannedWeborder?.error
  );

  const { device, NodeAppIP, NodeAppPort } = useSelector(
    (state) => state.queryStrings
  );
  useEffect(() => {
    console.log(
      `cncManualWebOrderObj.woStatus = ${JSON.stringify(cncManualWebOrderObj)}`
    );
    // console.log(`cncManualWebOrderObj.status = ${cncManualWebOrderObj.status}`);
    if (
      cncManualWebOrderObj.woStatus &&
      cncManualWebOrderObj.woStatus ===
        Constants.webOrderConst.status.ReadyForCollection
    ) {
      setToastState((prevState) => ({
        ...prevState,
        manualOrder: {
          visible: true,
          title: t(
            "clickAndCollectOrderModalBody.toast.orderReadyForCollection.title"
          ),
          desc: t(
            "clickAndCollectOrderModalBody.toast.orderReadyForCollection.desc"
          ),
          variant: toast.theme.informative,
        },
      }));
    } else if (
      cncManualWebOrderObj.woStatus &&
      cncManualWebOrderObj.woStatus ===
        Constants.webOrderConst.status.CustomerArrived
    ) {
      let counterNo = getCounterNo(cncManualWebOrderObj?.pickup_store_location);
      setToastState((prevState) => ({
        ...prevState,
        manualOrder: {
          visible: true,
          title: t("clickAndCollectOrderModalBody.toast.orderPrepared.title"),
          desc: prepareCounterToast(
            t("clickAndCollectOrderModalBody.toast.orderPrepared.desc"),
            counterNo
          ),
          variant: toast.theme.positive,
        },
      }));
    } else if (
      cncManualWebOrderObj?.woStatus &&
      cncManualWebOrderObj?.woStatus ===
        Constants.webOrderConst.status.CustomerCollected
    ) {
      setToastState((prevState) => ({
        ...prevState,
        manualOrder: {
          visible: true,
          title: t("clickAndCollectOrderModalBody.toast.orderCollected.title"),
          desc: t("clickAndCollectOrderModalBody.toast.orderCollected.desc"),
          variant: toast.theme.positive,
        },
      }));
    } else if (
      cncManualWebOrderObj?.woStatus &&
      cncManualWebOrderObj?.woStatus === Constants.webOrderConst.status.NotFound
    ) {
      setToastState((prevState) => ({
        ...prevState,
        manualOrder: { ...initialToastState.manualOrder },
      }));
    } else if (cncManualWebOrderObj.woStatus) {
      setToastState((prevState) => ({
        ...prevState,
        manualOrder: {
          visible: true,
          title: `Weborder status is ${cncManualWebOrderObj.woStatus}`,
          desc: `Weborder status is ${cncManualWebOrderObj.woStatus}`,
          variant: toast.theme.negative,
        },
      }));
    } else {
      setToastState(initialToastState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cncManualWebOrderObj]);

  useEffect(() => {
    if (cncManualWebOrderError) {
      setPromptModalState({ visible: true, message: cncManualWebOrderError });
    }
  }, [cncManualWebOrderError]);

  useEffect(() => {
    if (
      cncScannedWebOrderObj?.woStatus &&
      cncScannedWebOrderObj?.woStatus ===
        Constants.webOrderConst.status.ReadyForCollection
    ) {
      setToastState((prevState) => ({
        ...prevState,
        scannedOrder: {
          visible: true,
          title: t(
            "clickAndCollectOrderModalBody.toast.orderReadyForCollection.title"
          ),
          desc: t(
            "clickAndCollectOrderModalBody.toast.orderReadyForCollection.desc"
          ),
          variant: toast.theme.informative,
        },
      }));
    } else if (
      cncScannedWebOrderObj?.woStatus &&
      cncScannedWebOrderObj?.woStatus ===
        Constants.webOrderConst.status.CustomerArrived
    ) {
      let counterNo = getCounterNo(
        cncScannedWebOrderObj?.pickup_store_location
      );
      setToastState((prevState) => ({
        ...prevState,
        scannedOrder: {
          visible: true,
          title: t("clickAndCollectOrderModalBody.toast.orderPrepared.title"),
          desc: prepareCounterToast(
            t("clickAndCollectOrderModalBody.toast.orderPrepared.desc"),
            counterNo
          ),
          variant: toast.theme.positive,
        },
      }));
    } else if (
      cncScannedWebOrderObj?.woStatus &&
      cncScannedWebOrderObj?.woStatus ===
        Constants.webOrderConst.status.CustomerCollected
    ) {
      setToastState((prevState) => ({
        ...prevState,
        scannedOrder: {
          visible: true,
          title: t("clickAndCollectOrderModalBody.toast.orderCollected.title"),
          desc: t("clickAndCollectOrderModalBody.toast.orderCollected.desc"),
          variant: toast.theme.positive,
        },
      }));
    } else if (
      cncScannedWebOrderObj?.woStatus &&
      cncScannedWebOrderObj?.woStatus ===
        Constants.webOrderConst.status.NotFound
    ) {
      setToastState((prevState) => ({
        ...prevState,
        scannedOrder: { ...initialToastState.scannedOrder },
      }));
    } else if (cncScannedWebOrderObj?.woStatus) {
      setToastState((prevState) => ({
        ...prevState,
        scannedOrder: {
          visible: true,
          title: `Weborder status is ${cncScannedWebOrderObj?.woStatus}`,
          desc: `Weborder status is ${cncScannedWebOrderObj?.woStatus}`,
          variant: toast.theme.negative,
        },
      }));
    } else {
      setToastState(initialToastState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cncScannedWebOrderObj]);

  useEffect(() => {
    if (
      cncScannedWebOrderObj.woNo &&
      cncScannedWebOrderObj.woStatus ===
        Constants.webOrderConst.status.ReadyForCollection
    ) {
      dispatch(
        modifyCNCScannedWeborderStatus({
          woId: cncScannedWebOrderObj.woId,
          woNo: cncScannedWebOrderObj.woNo,
          woStatus: Constants.webOrderConst.status.CustomerArrived,
          customerEntry: process.env.REACT_APP_CC_CUSTOMER_ENTRTY,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    cncScannedWebOrderObj.woNo,
    cncScannedWebOrderObj.woStatus,
    cncScannedWebOrderObj.woId,
  ]);

  useEffect(() => {
    if (cncScannedWebOrderError) {
      setPromptModalState({ visible: true, message: cncScannedWebOrderError });
    }
  }, [cncScannedWebOrderError]);

  useEffect(() => {
    if (NodeAppIP && NodeAppPort && device) {
      const socket = io(`ws://${NodeAppIP}:${NodeAppPort}`, {});
      if (
        device.toLowerCase() ===
        Constants.scannerDeviceType.network.toLowerCase()
      ) {
        socketSetup(socket);
      }
      return () => {
        console.warn("Socket disconnected");
        socket.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const socketSetup = async (socket) => {
    socket.on("connect", () => {
      console.log("Socket Connected", socket);
    });
    socket.on("connect_error", (err) => {
      console.log(`connect_error due to ${err.message}`);
      // setPromptModalState({
      //   visible: true,
      //   message: `Unable to connect to the Network Scanner - ${err.message}`,
      // });
    });
    socket.on("reconnect", (d) => {
      console.log("Socket reconnect", d);
    });
    socket.on("disconnect", () => {
      console.log("Socket Disconnected", socket);
    });
    socket.on("error", (err) => {
      console.log("Error occured", err);
      // setPromptModalState({
      //   visible: true,
      //   message: `Unable to connect to the Network Scanner - ${err}`,
      // });
    });
    socket.on("TCP_IP_DATA", function (socketData) {
      console.log("Recieved TCP_IP_DATA", socketData);
      handleScan(socketData.data_string);
    });
  };

  const initialManualValues = {
    manualOrderNumber: "",
  };
  const initialScannedValues = {
    scannedOrderNumber: "",
  };

  const orderNumberRegExpStr = `^\\d{${
    Constants[localStorage.countryCode].cncWebOrderNumberLength
  }}$`;

  const orderNumberRegExp = new RegExp(orderNumberRegExpStr);

  const validationSchemaManualEntry = Yup.object({
    manualOrderNumber: Yup.string()
      .required(
        t(
          "clickAndCollectOrderModalBody.manualOrderNumber.textField.required.text"
        )
      )
      .matches(
        orderNumberRegExp,
        t(
          "clickAndCollectOrderModalBody.manualOrderNumber.textField.valid.text"
        )
      ),
  });

  const validationSchemaScannedEntry = Yup.object({
    scannedOrderNumber: Yup.string()
      .required(
        t(
          "clickAndCollectOrderModalBody.scannedOrderNumber.textField.required.text"
        )
      )
      .matches(
        orderNumberRegExp,
        t(
          "clickAndCollectOrderModalBody.scannedOrderNumber.textField.valid.text"
        )
      ),
  });

  const handleCancelBtnClick = ({ resetForm }) => {
    dispatch(resetCNCManualWeborderStatus());
    resetForm();
    setToastState(initialToastState);
  };

  const handleCheckNowClick = ({ values }) => {
    console.log(`handleCheckNowClick = ${values.manualOrderNumber}`);
    dispatch(
      fetchCNCManualWeborderStatus({
        weborderNo: `WEBO${values.manualOrderNumber}`,
      })
    );
  };

  const handleCollectOrderClick = ({ resetForm }) => {
    dispatch(
      modifyCNCManualWeborderStatus({
        woId: cncManualWebOrderObj.woId,
        woNo: cncManualWebOrderObj.woNo,
        woStatus: Constants.webOrderConst.status.CustomerArrived,
        customerEntry: process.env.REACT_APP_CC_CUSTOMER_ENTRTY,
      })
    );
    resetForm();
  };

  const isWebOrderNoValid = ({ webOrderNo }) => {
    const { webOrderNoLength } = Constants[localStorage.countryCode];
    const validationRegExStr = `^WEBO\\d{${webOrderNoLength}}$`;
    const regexp = new RegExp(validationRegExStr);
    return regexp.test(webOrderNo);
  };

  const handleScan = (data) => {
    data = data
      .toString()
      .trim()
      .replace(/[\r\n]/gm, "");
    dispatch(setCNCScannedData({ text: data }));
    if (!isWebOrderNoValid({ webOrderNo: data })) {
      console.log(`Web Order number is not in proper format`);
      return;
    } else {
      if (disableScan.current) {
        console.log(`cannot proceed with scan, scan disabled !!`);
        return;
      } else {
        dispatch(fetchCNCScannedWeborderStatus({ weborderNo: data }));
        disableScan.current = true;
        setTimeout(() => {
          disableScan.current = false;
        }, 1000);
      }
    }
  };

  const handleError = () => {};

  const handleFormKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  return (
    <div className="cnc-wo-status-modal-body" dir={isRtl() ? "rtl" : "ltr"}>
      {/* <SocketClient langCode={localStorage.countryCode} /> */}
      <BarcodeReader onError={handleError} onScan={handleScan} />
      <div className="header">
        <div className="header-title">
          {t("clickAndCollectOrderModalBody.header.title")}
        </div>
        <div className="header-desc">
          {t("clickAndCollectOrderModalBody.header.desc")}
        </div>
      </div>
      <hr />
      <div
        className="cnc-wo-status-modal-body--form-container"
        data-mode={mode}
      >
        <Formik
          initialValues={initialScannedValues}
          validationSchema={validationSchemaScannedEntry}
        >
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setStatus,
            status,
            isValid,
            dirty,
            /* and other goodies */
          }) => (
            <form onKeyDown={handleFormKeyDown}>
              <div className="order-number-text-field-container">
                <div className="form-field">
                  <div className="input-field label-wrapper label-wrapper--text-input">
                    <label
                      htmlFor="scannedOrderNumber"
                      title={t(
                        "clickAndCollectOrderModalBody.barcodeScan.orderNumber.textField.label"
                      )}
                    >
                      {t(
                        "clickAndCollectOrderModalBody.barcodeScan.orderNumber.textField.label"
                      )}
                    </label>
                    <div
                      className="input-field__wrapper"
                      dir={isRtl() ? "rtl" : "ltr"}
                    >
                      <input
                        type="text"
                        aria-describedby="scannedOrderNumber"
                        aria-required="false"
                        name="scannedOrderNumber"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={cncScannedWebOrderObj?.woNo ?? ""}
                        readOnly
                        placeholder={t(
                          "clickAndCollectOrderModalBody.barcodeScan.orderNumber.textField.placeholder"
                        )}
                        maxLength={
                          Constants[localStorage.countryCode]
                            .cncWebOrderNumberLength
                        }
                        autoComplete="off"
                      />
                      <span className="input-field__border"></span>
                    </div>
                  </div>
                  <div className="inline-error-msg-space">
                    {cncScannedWebOrderObj &&
                      cncScannedWebOrderObj?.scannedData &&
                      !isWebOrderNoValid({
                        webOrderNo: cncScannedWebOrderObj?.scannedData,
                      }) && (
                        <div className="validation-error-msg-space">
                          <ValidationErrorMessage>
                            <SSRIcon paths={infoIcon} />
                            {t(
                              "clickAndCollectOrderModalBody.scannedOrderNumber.textField.valid.text"
                            )}
                          </ValidationErrorMessage>
                        </div>
                      )}
                    {cncScannedWebOrderObj?.woStatus &&
                      cncScannedWebOrderObj?.woStatus ===
                        Constants.webOrderConst.status.NotFound && (
                        <div className="speci-server-error-msg-space">
                          <ValidationErrorMessage>
                            <SSRIcon paths={infoIcon} />
                            {t(
                              "clickAndCollectOrderModalBody.scannedOrderNumber.textField.server.notFound.text"
                            )}
                          </ValidationErrorMessage>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="toast-container">
                {toastState.scannedOrder.visible && (
                  <CustomInlineToast
                    visible={toastState.scannedOrder.visible}
                    title={toastState.scannedOrder.title}
                    body={toastState.scannedOrder.desc}
                    variant={toastState.scannedOrder.variant}
                    onClose={() => {
                      setToastState((prevState) => ({
                        ...prevState,
                        scannedOrder: {
                          ...prevState.scannedOrder,
                          visible: false,
                        },
                      }));
                      dispatch(resetCNCScannedWeborderStatus());
                    }}
                  />
                )}
              </div>
            </form>
          )}
        </Formik>
        <hr />
        <Formik
          initialValues={initialManualValues}
          validationSchema={validationSchemaManualEntry}
        >
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setStatus,
            status,
            isValid,
            dirty,
            resetForm,
            /* and other goodies */
          }) => (
            <form onKeyDown={handleFormKeyDown}>
              <div className="email-text-field-container">
                <div className="form-field">
                  <div className="input-field label-wrapper label-wrapper--text-input">
                    <label
                      htmlFor="manualOrderNumber"
                      title={t(
                        "clickAndCollectOrderModalBody.manual.orderNumber.textField.label"
                      )}
                    >
                      {t(
                        "clickAndCollectOrderModalBody.manual.orderNumber.textField.label"
                      )}
                    </label>
                    <div
                      className="input-field__wrapper"
                      dir={isRtl() ? "rtl" : "ltr"}
                    >
                      <div className="order-number-prefix">
                        {t(
                          "clickAndCollectOrderModalBody.manual.orderNumber.textField.prefix"
                        )}
                      </div>
                      <input
                        type="text"
                        aria-describedby="manualOrderNumber"
                        aria-required="false"
                        id="manualOrderNumber"
                        name="manualOrderNumber"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.manualOrderNumber ?? ""}
                        placeholder={t(
                          "clickAndCollectOrderModalBody.manual.orderNumber.textField.placeholder"
                        )}
                        maxLength={
                          Constants[localStorage.countryCode]
                            .cncWebOrderNumberLength
                        }
                        autoComplete="off"
                      />
                      <span className="input-field__border"></span>
                    </div>
                  </div>
                  <div className="inline-error-msg-space">
                    <div className="validation-error-msg-space">
                      {/* <SSRIcon paths={infoIcon} /> */}
                      <ErrorMessage
                        name="manualOrderNumber"
                        component={ValidationErrorMessage}
                      />
                    </div>
                    {cncManualWebOrderObj?.woStatus &&
                      cncManualWebOrderObj?.woStatus ===
                        Constants.webOrderConst.status.NotFound && (
                        <div className="speci-server-error-msg-space">
                          <SSRIcon paths={infoIcon} />
                          <ValidationErrorMessage>
                            {t(
                              "clickAndCollectOrderModalBody.manualOrderNumber.textField.server.notFound.text"
                            )}
                          </ValidationErrorMessage>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="btns-container">
                {(!cncManualWebOrderObj.woStatus ||
                  cncManualWebOrderObj.woStatus !==
                    Constants.webOrderConst.status.ReadyForCollection) && (
                  <Button
                    className="check-now-btn"
                    type="emphasised"
                    text={t("clickAndCollectOrderModalBody.checkNowBtn.text")}
                    disabled={!(dirty && isValid)}
                    onClick={() => handleCheckNowClick({ values })}
                  />
                )}
                {cncManualWebOrderObj.woStatus ===
                  Constants.webOrderConst.status.ReadyForCollection && (
                  <>
                    <Button
                      className="verify-btn"
                      type="emphasised"
                      text={t("clickAndCollectOrderModalBody.cancelBtn.text")}
                      onClick={() => handleCancelBtnClick({ resetForm })}
                      disabled={!(dirty && isValid)}
                    />
                    <Button
                      disabled={!(dirty && isValid)}
                      className="retrieve-voucher-btn"
                      type="emphasised"
                      onClick={() => handleCollectOrderClick({ resetForm })}
                      text={t(
                        "clickAndCollectOrderModalBody.collectOrderBtn.text"
                      )}
                    />
                  </>
                )}
              </div>
              <div className="toast-container">
                {toastState.manualOrder.visible && (
                  <CustomInlineToast
                    visible={toastState.manualOrder.visible}
                    title={toastState.manualOrder.title}
                    icon={informationCircle}
                    body={toastState.manualOrder.desc}
                    variant={toastState.manualOrder.variant}
                    onClose={() => {
                      setToastState((prevState) => ({
                        ...prevState,
                        manualOrder: {
                          ...prevState.manualOrder,
                          visible: false,
                        },
                      }));
                      dispatch(resetCNCManualWeborderStatus());
                      resetForm();
                    }}
                  />
                )}
              </div>
            </form>
          )}
        </Formik>
      </div>
      {promptModalState.visible && (
        <PromptModalContainer
          visible={promptModalState.visible}
          onOkay={() => setPromptModalState(initialPromptModalState)}
        >
          {promptModalState.message}
        </PromptModalContainer>
      )}
    </div>
  );
};

export default ClickAndCollectOrderModalBody;
